import script from "./myOrder.vue?vue&type=script&setup=true&lang=js"
export * from "./myOrder.vue?vue&type=script&setup=true&lang=js"

import "./myOrder.vue?vue&type=style&index=0&id=12ec38be&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-12ec38be"]])

export default __exports__